import { MapListingCard } from '@src/components/Card';
import { getPageUrlPath } from '@src/utils/url';
import React from 'react';
import { MapListingCardType } from '@src/types/map';

const MapListingGrid = ({ mapData }: { mapData: Record<string, any> }) => {
  const newCards: MapListingCardType[] = [];

  mapData?.forEach((item: Record<string, any>) => {
    const path = getPageUrlPath(item);

    const card = {
      communitySlug: path ? path : '',
      forSaleSlug: path ? path + 'for-sale' : '',
      state: item.state?.slug ? item.state?.slug.toUpperCase() : '',
      title: item.title,
      image: item.mapAssets?.mediaItem,
      suburb: item.suburb?.name,
      subtext: item?.findYourCommunityCardSubtext
    };

    newCards.push(card);
  });

  return mapData ? (
    <>
      {newCards?.map((card, index) => (
        <MapListingCard
          key={index}
          title={card.title}
          image={card.image}
          forSaleSlug={card.forSaleSlug}
          communitySlug={card.communitySlug}
          state={card.state}
          suburb={card.suburb}
          subtext={card.subtext}
        />
      ))}
    </>
  ) : (
    <></>
  );
};

export default MapListingGrid;
